import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance, axiosNewApiInstance } from "../../services/api.js";

//Get all archive data +
export const getAllArchiveData = createAsyncThunk(
  "archive/getAllArchiveData",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/archive/in_archive/`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Add item to archive +
export const addItemToArchive = createAsyncThunk(
  "archive/addItemToArchive",
  async (itemData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/archive/in_archive/`,
        itemData
      );
      console.log("addItemToArchive", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Помилка сервера"
      );
    }
  }
);

// Edit item in archive +
export const updateArchiveItem = createAsyncThunk(
  "archive/updateArchiveItem",
  async ({ archive_id, reason_add_name }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/archive/in_archive/${archive_id}`,
        { reason_add_name }
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred during request:", error);

      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Return item from archive +
export const returnArchiveItem = createAsyncThunk(
  "archive/returnArchiveItem",
  async (returnedItemData, thunkAPI) => {
    try {
      const { archive_id, status } = returnedItemData;
      const response = await axiosNewApiInstance.patch(
        `/api/v1/archive/return_archive/`,
        null,
        {
          params: { archive_id, status },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Помилка при запиті до сервера:", error);
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get current archive stats +
export const getCurrentArchiveStats = createAsyncThunk(
  "archive/getCurrentArchiveStats",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/archive/current_archive`
      );
      return response.data;
    } catch (error) {
      console.error("Помилка при запиті до сервера:", error);
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);


    